import { useRef } from 'react'
import { ActionList } from './actions-section/action-list'
import { PopularQuestionsList } from './popular-questions-section/popular-questions-list'

import { useStyles } from './styles'
import { WebChatbot } from './web-chatbot'
import { Box } from '@mui/material'

export const TraicyChatbotComponent = () => {
  const chatbotRef = useRef<HTMLDivElement | null>(null)
  const chatbotMethodsRef = useRef<{ submitMessage: (message: string) => void } | null>(null)

  const classes = useStyles()

  const handleScrollToChatbot = () => {
    if (chatbotRef?.current) {
      chatbotRef.current?.scrollIntoView({ behavior: 'smooth' })
    }
  }

  const handlePopularQuestionClick = (text: string) => {
    if (chatbotRef?.current && chatbotMethodsRef?.current) {
      chatbotRef.current.scrollIntoView({ behavior: 'smooth' })
      chatbotMethodsRef.current.submitMessage(text)
    }
  }

  return (
    <div className={classes.wrapperContainer}>
      <p className={classes.heading}>
        Meet <span className={classes.textHighlight}>Traicy</span>, your AI-powered guide on
        sustainability, trained to provide insights on ethical choices and support brands on their
        ESG journey.
      </p>
      <ActionList onWebChatbotClick={handleScrollToChatbot} />

      <PopularQuestionsList onQuestionClick={handlePopularQuestionClick} />

      <Box
        sx={{
          width: '100%',
          maxWidth: '840px',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
        ref={chatbotRef}
      >
        <WebChatbot ref={chatbotMethodsRef} />
      </Box>
    </div>
  )
}
